<template>
  <div class="block-item-container">
    <div class="block-item-title-content flex justify-between items-center">
      <div class="title">用户提问</div>
    </div>
    <div class="job-url-content" :class="{ empty: !process.question }">
      {{ process.question || "未填写" }}
    </div>
    <div class="block-item-title-content flex justify-between items-center">
      <div class="title">申请职位</div>
    </div>
    <div
      class="job-url-content cursor-pointer"
      :class="{ empty: !process.job_url }"
      @click="openJobUrl"
    >
      {{ process.job_url || "未填写" }}
    </div>
    <div class="block-item-title-content flex justify-between items-center">
      <div class="title">问题回复</div>
      <i
        class="iconfont iconchevron-down"
        :class="{ active: questionVisible }"
        @click="questionVisible = !questionVisible"
      ></i>
    </div>
    <el-collapse-transition>
      <div v-show="questionVisible" class="questions-list-content">
        <template v-if="comments.length">
          <div
            v-for="(item, index) in comments"
            :key="index"
            class="comment-list"
          >
            <div
              v-for="(message, messageIndex) in item"
              :key="messageIndex"
              class="message-item-content"
            >
              <div class="message-info flex justify-between items-center">
                <div class="flex items-center">
                  <img :src="message.creator_avatar" alt="" class="avatar" />
                  <div class="name">{{ message.creator_name }}</div>
                </div>
                <div class="time">{{ message.create_time }}</div>
              </div>
              <div v-html="message.desc" class="message"></div>
            </div>
          </div>
        </template>
        <div
          v-if="process.task.state !== 'end'"
          class="textarea-content relative"
        >
          <el-input
            class="mentor-reply-input"
            type="textarea"
            v-model="content"
            placeholder="请输入"
            rows="4"
            resize="none"
          />
          <CompleteBtn
            :text="platform === 'mentor' ? '回答' : '提问'"
            class="reply-btn"
            @clickBtn="reply"
          />
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import api from "@/api";
import { dealSignatrue, routerTo } from "@/assets/js/util";
import CompleteBtn from "../CompleteButton/CompleteButton.vue";

export default {
  name: "Conversation",
  components: {
    CompleteBtn,
  },
  props: {
    process: {
      type: Object,
      default: () => ({}),
    },
    platform: {
      type: String,
      default: "user",
    },
  },
  data() {
    return {
      content: "",
      questionVisible: true,
    };
  },
  computed: {
    comments() {
      let comments = [];
      for (let i = 0; i < this.process.mentor_round; i++) {
        let item = this.process.comments[i + 1] || [];
        comments.push(item);
      }
      return comments;
    },
  },
  methods: {
    openJobUrl() {
      if (!this.process.job_url) return;
      routerTo(this.process.job_url, "_blank");
    },
    async reply() {
      try {
        if (!this.content) {
          this.$message.error("请填写内容");
          return false;
        }
        let params = {
          description: this.content,
          mentor_round: this.comments.length,
        };
        params = await dealSignatrue(params);
        let res = await api.cvsEditor.createTaskComment(
          this.$store.state.editor.cvDetail.basic_info.token,
          params
        );
        if (res.code === 1000) {
          this.$message.success("提交成功");
          this.content = "";
          this.$emit("refresh");
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.block-item-title-content {
  .iconfont {
    color: #8d99aa;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transform: rotate(0deg);
    transition: transform 0.3s ease-in-out;
    &.active {
      transform: rotate(180deg);
    }
  }
}
.job-url-content {
  background-color: $page-bg-sub-color;
  padding: 12px 18px;
  color: $mentor-job-text-color;
  border-radius: 8px;
  margin-bottom: 32px;
  &.empty {
    color: $placeholder-color;
  }
}
.questions-list-content {
  .comment-list {
    .message-item-content {
      margin-bottom: 16px;
      .message-info {
        margin-bottom: 4px;
        .avatar {
          width: 24px;
          height: 24px;
          margin-right: 8px;
          border-radius: 50%;
        }
        .name {
          color: #5a616e;
        }
        .time {
          font-size: 12px;
          color: #8d99aa;
        }
      }
      .message {
        color: $text-color;
        padding-left: 32px;
        white-space: pre-line;
      }
    }
  }
  .textarea-content {
    .mentor-reply-input {
      ::v-deep(.el-textarea__inner) {
        background-color: $page-bg-sub-color;
        border-radius: 8px;
        padding: 18px 18px 46px;
        border: none;
        color: $text-color;
      }
    }
    .reply-btn {
      position: absolute;
      bottom: 18px;
      right: 18px;
      width: 80px;
      height: 28px;
      border-radius: 18px;
      white-space: nowrap;
    }
  }
}
</style>
